export const authPaths = ["/auth/signin", "/auth/signup", "/auth/reset-password", "/auth/token/refresh"];

export const withoutMasterLoginPaths = ["/auth/signup/verify-email", "/auth/signup/verify-email/resend"];
